import { html } from 'lit';
import { PublicFooter } from '../../../client/public-footer.js';
export const SGSBConfirmPage = () =>
  html`<div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
    <main class="mx-auto w-full max-w-2xl flex-1 p-4 sm:p-6">
      <section class="card">
        <div class="card-body gap-4">
          <span class="icon-[material-symbols--check-circle-rounded] text-4xl text-primary" aria-hidden="true"></span>
          <h1 class="text-2xl font-semibold">Bestätigung erfolgreich</h1>
          <p>
            Ihre Daten stehen jetzt im Bewerbungsformular zur Verfügung. Falls die Bewerbung bereits abgesendet wurde,
            wird Ihr Zugang automatisch mit den Daten verknüpft.
          </p>
          <a class="btn btn-primary" href="/sus-schulen">Zur Schulauswahl</a>
        </div>
      </section>
    </main>
    ${PublicFooter()}
  </div>`;
